import { AlertTriangle, Blocks, Boxes, Clock3, PlugZap, Users } from "lucide-react";
import { Navigate } from "react-router-dom";

import { useApp } from "../context/AppContext";

const cards = [
  ["projets", "Projets", Boxes],
  ["templates_entreprise", "Templates privés", Blocks],
  ["membres_actifs", "Membres actifs", Users],
  ["modules_actifs", "Modules actifs", PlugZap]
] as const;

function TrialBanner() {
  const { bootstrap } = useApp();
  if (bootstrap?.subscription?.status !== "TRIAL") return null;
  return (
    <div className="mb-6 flex flex-wrap items-center justify-between gap-3 rounded-xl border border-emerald-200 bg-emerald-50 px-4 py-3 text-sm">
      <div className="flex items-center gap-3">
        <Clock3 size={18} className="text-emerald-700" />
        <span><strong>Essai SahelTech actif</strong> · Plan {bootstrap.subscription.plan}</span>
      </div>
      <span className="font-semibold text-slate-600">
        jusqu’au {bootstrap.subscription.trial_ends_at ? new Date(bootstrap.subscription.trial_ends_at).toLocaleDateString("fr-FR") : "—"}
      </span>
    </div>
  );
}

export function DashboardPage() {
  const { bootstrap } = useApp();
  const summary = bootstrap?.summary;
  const formationEnabled = Boolean(bootstrap?.business_app_access?.formation);

  if (formationEnabled) {
    return <Navigate to="/formation" replace />;
  }

  return (
    <div>
      <div>
        <div className="text-sm font-semibold text-emerald-700">Vue d’ensemble</div>
        <h1 className="mt-1 text-3xl font-black text-slate-950">{bootstrap?.active_organisation?.nom}</h1>
        <p className="mt-2 text-sm text-slate-500">État opérationnel de la plateforme pour l’entreprise active.</p>
      </div>

      <div className="mt-5"><TrialBanner /></div>

      <div className="mt-7 grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
        {cards.map(([key, label, Icon]) => (
          <div key={key} className="panel p-5">
            <div className="flex items-center justify-between">
              <span className="text-sm font-semibold text-slate-500">{label}</span>
              <span className="grid size-9 place-items-center rounded-xl bg-slate-100 text-slate-700"><Icon size={18} /></span>
            </div>
            <div className="mt-4 text-3xl font-black text-slate-950">{summary?.[key] ?? 0}</div>
          </div>
        ))}
      </div>

      <div className="mt-6 grid gap-6 xl:grid-cols-[1.4fr_1fr]">
        <section className="panel p-6">
          <h2 className="text-lg font-bold">Projets par statut</h2>
          <div className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {(summary?.projets_par_statut || []).map((item) => (
              <div key={item.statut} className="rounded-xl border border-slate-100 bg-slate-50 p-4">
                <div className="text-xs font-bold uppercase tracking-wide text-slate-500">{item.statut}</div>
                <div className="mt-2 text-2xl font-black">{item.total}</div>
              </div>
            ))}
            {!summary?.projets_par_statut?.length && <p className="text-sm text-slate-500">Aucun projet pour le moment.</p>}
          </div>
        </section>

        <section className="panel p-6">
          <h2 className="text-lg font-bold">Intégrations</h2>
          <div className="mt-5 space-y-3">
            <div className="flex items-center justify-between rounded-xl bg-amber-50 p-4 text-amber-900">
              <div className="flex items-center gap-3"><AlertTriangle size={18} /><span className="text-sm font-semibold">Événements en erreur</span></div>
              <strong>{summary?.outbox_failed ?? 0}</strong>
            </div>
            <div className="flex items-center justify-between rounded-xl bg-slate-50 p-4">
              <span className="text-sm font-semibold text-slate-700">Outbox en attente</span>
              <strong>{summary?.outbox_pending ?? 0}</strong>
            </div>
          </div>
        </section>
      </div>
    </div>
  );
}
